import { useConferenceStore } from '@cometchat/calls-sdk-core';
import clsx from 'clsx';
import { useEffect, useState } from 'react';
import './connection-loader.css';

function ConnectionLoader() {
  const conferenceJoined = useConferenceStore(state => state.conferenceJoined);
  const [shouldRender, setShouldRender] = useState(true);

  useEffect(() => {
    if (conferenceJoined) {
      const timer = setTimeout(() => {
        setShouldRender(false);
      }, 300);
      return () => clearTimeout(timer);
    }
  }, [conferenceJoined]);

  if (!shouldRender) {
    return null;
  }

  return (
    <div
      className={clsx('cometchat-calls-connection-loader-overlay', {
        'cometchat-calls-connection-loader-overlay--fade-out': conferenceJoined,
      })}
      data-testid="connecting-overlay">
      <div className="cometchat-calls-connection-loader-animation"></div>
    </div>
  );
}

export default ConnectionLoader;
